'use client';

import { c as _c } from "react/compiler-runtime";
import './outage-ribbon.scss';
import { useState } from 'react';
import { Alert, type AlertProps } from '@sola/ark-core/molecules/alert/alert.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
export interface OutageRibbonProps extends Pick<AlertProps, 'variant' | 'onClose'> {
  title?: string;
  message?: string;
  id?: string;
  className?: string;
}
export const OutageRibbon: React.FC<OutageRibbonProps> = t0 => {
  const $ = _c(20);
  const {
    title,
    message,
    className,
    id,
    variant: t1,
    onClose
  } = t0;
  const variant = t1 === undefined ? "warning" : t1;
  const [closed, setClosed] = useState(false);
  if (closed || !title || !message) {
    return null;
  }
  const t2 = `OutageRibbon--${variant}`;
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("OutageRibbon", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = variant === "negative" ? "alert" : "status";
  const t5 = variant === "negative" ? "assertive" : "polite";
  const t6 = id ? `outage-${id}` : undefined;
  let t7;
  if ($[3] !== onClose) {
    t7 = () => {
      setClosed(true);
      onClose?.();
    };
    $[3] = onClose;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== title) {
    t8 = <span className="body body-md">{title}</span>;
    $[5] = title;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== message) {
    t9 = <span className="body body-sm">{message}</span>;
    $[7] = message;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t7 || $[10] !== t8 || $[11] !== t9 || $[12] !== variant) {
    t10 = <div className="OutageRibbon__container"><Alert variant={variant} closable={true} onClose={t7} title={t8} message={t9} /></div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
    $[12] = variant;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t11 = <section className={t3} role={t4} aria-live={t5} data-tracking-id={t6}>{t10}</section>;
    $[14] = t10;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
export default OutageRibbon;